export default "__VITE_ASSET__Kr3HSPTU__"